import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-sia-loading',
  templateUrl: './sia-loading.component.html',
  styleUrls: ['./sia-loading.component.scss']
})
export class SiaLoadingComponent implements OnInit, OnChanges {
  @Input() show: SimpleChanges;
  isShown = false;

  constructor() {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.show.currentValue != null) {
      this.isShown = changes.show.currentValue;
    }
  }

  ngOnInit() {}
}
